export const PublicIcon = (props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="32" height="32" rx="5" fill="#6366F1" />
      <circle cx="16" cy="16" r="8.5" stroke="white" />
    </svg>
  );
};
